import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import HomePage from "./Pages/Home/HomePage";
import WorkPage from "./Pages/Work/WorkPage";
import OfferingPage from "./Pages/Offering/OfferingPage";
import CaseStudyPage from "./Pages/CaseStudy/CaseStudyPage";
import AboutUsPage from "./Pages/AboutUs/AboutUsPage";
import CareersPage from "./Pages/Careers/CareersPage";
import ContactUsPage from "./Pages/ContactUs/ContactUsPage";
import CareerFormPage from "./Pages/CareerForm/CareerForm";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import ScrollToTop from "./Components/ScrollToTop";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/case-studies" element={<WorkPage />} />
        <Route path="/case-study/:id" element={<CaseStudyPage />} />
        <Route path="/offerings" element={<OfferingPage />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/contact" element={<ContactUsPage />} />
        <Route path="/:id/form" element={<CareerFormPage />} />

        {/* catch-all route: navigate to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  </React.StrictMode>
);
